import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSlideAdd: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconSlideAdd"><Path fillRule="evenodd" clipRule="evenodd" d="M2 2V18H6V22H22V6H18V2H2ZM16 6V4H4V16H6V6H16ZM15 10V13H18V15H15V18H13V15H10V13H13V10H15Z" fill="currentColor"/></CentralIconBase>;
});

export default IconSlideAdd;
